'use strict';
exports.test = function () {
  return true;
};

exports.install = function (t) {
  return function () {
    setTimeout(t, 0);
  };
};


// WEBPACK FOOTER //
// ./node_modules/immediate/lib/timeout.js